import React from "react";

export default function ComingSoon({ data }) {
  return (
    <section className="w-full">
      <img
        src={data.image}
        alt="Coming Soon"
        className="object-cover -md:hidden"
      />
      <img
        src={data.image_mobile}
        alt="Coming Soon2"
        className="object-cover w-full md:hidden"
      />
    </section>
  );
}
